import 'isomorphic-fetch'
import Calle from 'Calle'
import ErrorSinDatos from 'ErrorSinDatos'
import {ErrorCalleSinAlturas} from 'ErrorSinAlturas'
import core from '@usig-gcba/usig-core'

// Definicion del namespace
let usig;
if (typeof (usig) === "undefined")
	usig = {};

if (typeof (usig.data) === "undefined")
	usig.data = {};

if (typeof (usig.defaults) === "undefined")
	usig.defaults = {};
	
usig.defaults.Callejero = {
	server: 'https://servicios.usig.buenosaires.gob.ar/callejero',
	// server: '//liebre/wk/Callejero/src/www/server.php',
	lazyDataLoad: false,
	loadFullDatabase: true,
	callesEnMinusculas: true,
	encoding: 'utf-8',
	expirationTime: 10080 // una semana
};

/**
 * @class Callejero
 * Esta clase es la interfaz con el callejero de USIG. Es un singleton y todos los metodos estan accesibles
 * a traves de usig.Callejero. El componente debe inicializarse previamente llamando al metodo init.
 * @namespace usig
 * @cfg {String} server URL del servidor de datos de calles. Tiene un valor por defecto.
 * @cfg {Boolean} lazyDataLoad Determina si los datos del callejero deben cargarse al inicializar 
 * 		el componente o solo cuando se lo quiera usar por primera vez.
 * @cfg {Function} onReady Callback que es llamada cuando ya se cargaron los datos del callejero.
 * @singleton
*/
let opts = {},
    myself = this,
    initialized = false,
    listeners = {
        'ready': []
    },
    loadingData = false;

/**
 * Busca las palabras de la direccion ingresada, en las keyword de un registro del callejero
 * @param {Array} wordsRE Array de expresiones regulares de las palabras a buscar
 * @param {Array} calle Array con los datos de una calle del callejero
 * @return {boolean} true si todas las palabras de wordsRE coinciden con el comienzo de alguna palabra de las keywords de calle.
 */
function matchea(wordsRE, calle) {
    var match = true;
    for (var w=0;w<wordsRE.length;w++) {
        var r =  wordsRE[w];
        r.lastIndex = 0;
        if (!r.test(calle[2])){
            match = false;
            break;
        }
    }
    return match;
}

function mergeDatosCruces(data) {
    loadingData = false;
    if (data.length != usig.data.Callejero.length) {
        alert('Se produjo un error al cargar la información de cruces de calles.');
        return;
    }
    for (var i=0; i<usig.data.Callejero.length; i++) {
        usig.data.Callejero[i].push(data[i]);
    }
}

function guardarLocalStorage(data) {
  var expirationMS = opts.expirationTime * 60 * 1000;
  var record = { calles: JSON.stringify(data), expiration: new Date().getTime() + expirationMS };
  try {
    if (localStorage) localStorage["callejero"] = JSON.stringify(record);
  } catch (e) {
    console.error(e);
  }
}

function cargarCallejero(data) {
  initialized = true;
  usig.data.Callejero = data;
  loadingData = false;
  eventHandler('ready');
  return callejero;
}

function cargarCruces() {
    loadingData = true;

    fetch(opts.server + "?full=1&cruces=1&encoding=" + opts.encoding)
        .then(
            response => response.json(),
            error => console.log('Error!')
        )
        .then(json => mergeDatosCruces(json));
}

function _cargarCallejero() {
    loadingData = true;

    let data = opts.loadFullDatabase ? `?full=1&encoding=${opts.encoding}&minusculas=${opts.callesEnMinusculas? 1:0}` : `?encoding=${opts.encoding}&minusculas=${opts.callesEnMinusculas? 1:0}`;
    return fetch(opts.server + data + "&date=" + Date.now())
        .then(
            response => response.json()
        ).catch(error => {throw (error)})
        .then(
          (json) => {
              guardarLocalStorage(json);
              return cargarCallejero(json)
          }
        ).catch(error => {throw (error)})
}
// Comollego puede enviar un callejero cargado en memoria
function cargarCalles(callejero) {
    if (!loadingData) {
        if (!supports_html5_storage()) {
            return callejero ? new Promise((resolve) => resolve(cargarCallejero(callejero))) : _cargarCallejero();
        }else{ // soporta HTML5

            var callejeroLocalStorage;
            try {
                if (localStorage["callejero"]) callejeroLocalStorage = JSON.parse(localStorage["callejero"]);

                if (callejeroLocalStorage && callejeroLocalStorage.calles && callejeroLocalStorage.calles.length > 500) {
                    // Ya hay una copia del callejero en localStorage
                    // Si la version guardada es vieja, se vuelve a buscar, sino se usa el guardado
                    // Si falla la busqueda, devuelvo el que tenia guardado
                    return (new Date().getTime() < callejeroLocalStorage.expiration) ? new Promise((resolve) => resolve(cargarCallejero(JSON.parse(callejeroLocalStorage.calles)))) : _cargarCallejero().catch((err) => cargarCallejero(JSON.parse(callejeroLocalStorage.calles)));
                }else{
                    // Si no hay datos en localStorage, uso el callejero que me pasan
                    if (callejero) {
                        guardarLocalStorage(callejero);
                      return new Promise((resolve) => resolve(cargarCallejero(callejero)));
                    }
                    // Si no me pasaon ninguno, lo voy a buscar
                    return _cargarCallejero().catch((err) => {throw (err)});
                }
            } catch(e) {
                // Por si falla algun paso, se va a buscar el callejero o se usa el que me pasan
                console.error(e);
                return callejero ? new Promise((resolve) => resolve(cargarCallejero(callejero))) : _cargarCallejero();
            }
        }
    }
}

function supports_html5_storage() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
}

function eventHandler(ev) {
    for (var i=0; i<listeners[ev].length; i++) {
        listeners[ev][i]();
    }
}

function setHandler(ev, handler) {
    var found = false;
    for (var i=0; i < listeners[ev].length; i++) {
        found = found || (listeners[ev][i] == handler);
    }
    if (!found) {
        listeners[ev].push(handler);
    }
}

const callejero = {
    /**
     * Inicializa el componente previo a su primer uso.
     * @param {Object} options (optional) Objeto conteniendo overrides para las opciones por defecto.
     * @return {Object} Devuelve una referencia al componente.
     */
    init: (options) => {
        opts = Object.assign({}, usig.defaults.Callejero, options);

        if (typeof(opts.onReady) === "function") {
            setHandler('ready', opts.onReady);
        }
        if ((!usig.data.Callejero && !opts.lazyDataLoad) || (usig.data.Callejero && (usig.data.Callejero.calles || (usig.data.Callejero.calles && usig.data.Callejero.calles.length < 500)))) {
            return cargarCalles(opts.callejero).catch((err) => {
                // Si falla la busqueda y tengo un callejero en memoria, devuelvo ese.
                if (opts.callejero) return cargarCallejero(opts.callejero);
                throw(err);
            });
        } else if (usig.data.Callejero) {
            eventHandler('ready');
            listeners['ready'] = [];
        }
        return new Promise((resolve) => resolve(callejero));
    },

    /**
     * Pide los datos de las calles.
     * @param {Object} options (optional) Objeto indicando que hacer en el caso de que ya existan datos para las calles.
     * @return {Promise} promise conteniendo el objeto callejero actual o con los datos actualizados.
     */
    cargarCalles: (options) => {
        if (options && callejero.listo()) return options.override ? cargarCalles() : new Promise((resolve) => resolve(callejero));
        return cargarCalles();
    },
    /**
     * Busca calle por codigo y devuelve una lista de objetos calle
     * @param {int} codigo Codigo de calle a buscar
     * @return {Array of Calle} Calles encontradas
     * @throws {ErrorSinDatos} excepcion si no hay datos cargados.
     */
    buscarPorCodigo: (codigo) => {
        if (!callejero.listo()) throw new ErrorSinDatos();
        var calles = [];
        if(/^[0-9]+$/.test(codigo)){
            var index = core.binarySearch(usig.data.Callejero, codigo, (a, b) => a[0]-b);
            if (index > -1){
                var match = usig.data.Callejero[index];
                calles.push(Calle.construirCalle(match[0], match[1]));
                let i = index + 1;
                while(i < usig.data.Callejero.length && usig.data.Callejero[i][0] === codigo){
                    match = usig.data.Callejero[i];
                    calles.push(Calle.construirCalle(match[0], match[1]));
                    i++;
                }
                i = index - 1;
                while(i >= 0 && usig.data.Callejero[i][0] === codigo){
                    match = usig.data.Callejero[i];
                    calles.unshift(Calle.construirCalle(match[0], match[1]));
                    i--;
                }
            }
        }
        return calles;
    },
    /**
     * Devuelve las alturas de una calle a partir de su codigo
     * @param {int} codigo Codigo de calle a buscar
     * @return {Array of int} Alturas encontradas
     * @throws {ErrorSinDatos} excepcion si no hay datos cargados.
     */
    getAlturas: (codigo, nombre) => {
        if (!callejero.listo()) throw new ErrorSinDatos();
        var alturas = [];
        if(/^[0-9]+$/.test(codigo)){
            var index = core.binarySearch(usig.data.Callejero, codigo, (a, b) => a[0]-b);
            if (index > -1){
                var match = usig.data.Callejero[index];
                if (match[1] === nombre) match[3].forEach(alt => alturas.push(alt));
                let i = index + 1;
                while (i < usig.data.Callejero.length && usig.data.Callejero[i][0] === codigo) {
                    if (usig.data.Callejero[i][1] === nombre) {
                        match = usig.data.Callejero[i];
                        match[3].forEach(function (alt) {
                            return alturas.push(alt);
                        });
                    }
                    i++;
                }
                i = index - 1;
                while (i >= 0 && usig.data.Callejero[i][0] === codigo) {
                    if (usig.data.Callejero[i][1] === nombre) {
                        match = usig.data.Callejero[i];
                        match[3].forEach(function (alt) {
                            return alturas.push(alt);
                        });
                    }
                    i--;
                }
            }
        }
        return alturas;
    },
    /**
     * Devuelve los cruces de una calle a partir de su codigo y su nombre
     * @param {int} codigo Codigo de calle a buscar
     * @param {string} nombre Codigo de calle a buscar
     * @return {Array of int} Alturas encontradas
     * @throws {ErrorSinDatos} excepcion si no hay datos cargados.
     */
    getCruces: (codigo, nombre) => {
        if (!callejero.listo()) throw new ErrorSinDatos();
        var cruces = [];
        if(/^[0-9]+$/.test(codigo)){
            var index = core.binarySearch(usig.data.Callejero, codigo, (a, b) => a[0]-b);
            if (index > -1){
                var match = usig.data.Callejero[index];
                if (match[1] === nombre) match[4].forEach(alt => cruces.push(alt));
                let i = index + 1;
                while (i < usig.data.Callejero.length && usig.data.Callejero[i][0] === codigo) {
                    if (usig.data.Callejero[i][1] === nombre){
                      match = usig.data.Callejero[i];
                      match[4].forEach(function (alt) {
                        return cruces.push(alt);
                      });
                    }
                    i++;
                }
                i = index - 1;
                while (i >= 0 && usig.data.Callejero[i][0] === codigo) {
                    if (usig.data.Callejero[i][1] === nombre) {
                      match = usig.data.Callejero[i];
                      match[4].forEach(function (alt) {
                        return cruces.push(alt);
                      });
                    }
                    i--;
                }
            }
        }
        return cruces;
    },
    /**
     * Verifica si la calle (instancia de la clase usig.Calle) recibida como parametro
     * se cruza con esta
     * @param {usig.Calle} calle1 Calle a verificar si se intersecta con esta
     * @param {usig.Calle} calle2 Calle a verificar si se intersecta con esta
     * @return {Boolean} True en caso de que exista el cruce correspondiente
     */
    seCruzaCon: (calle1, calle2) => {
        const cruces1 = callejero.getCruces(calle1.codigo, calle1.nombre);
        if (cruces1) {
            return cruces1.indexOf(calle2.codigo) >= 0;
        }
    },
    /**
     * Busca calles cuyo nombre se corresponda con str y devuelve un array con todas las instancias
     * de usig.Calle halladas
     * @param {String} str String a matchear
     * @param {Integer} limit Maximo numero de respuestas a devolver
     * @return {Array} Array de instancias de usig.Calle que matchearon str
     */
    matcheaCalle: (str, limit) => {
        if (!callejero.listo()) throw new ErrorSinDatos();
        var opts = [];
        var optsLowPrior = [];
        var input = core.translate(str.replace(/"/g, ""), 'áéíóúüÁÉÍÓÚÜàèìòùÀÈÌÒÙ', 'aeiouuAEIOUUaeiouAEIOU').toUpperCase().trim();
        var words = input.split(' ');
        const wordsRE = words.map(function(w){return new RegExp("^"+w+"| "+w, "gi")});
        var snoRE = new RegExp("SNO|SIN NOMBRE OFICIAL|NO OFICIAL|PASAJE|PJE",'i');
        if (callejero.listo()) {
            for (var c=0;c<usig.data.Callejero.length;c++) {
                if (matchea(wordsRE, usig.data.Callejero[c])) {
                    /** almaceno las calles que no tienen nombre oficial o altura en una lista de baja prioridad **/
                    if (!snoRE.test(usig.data.Callejero[c][1]) && usig.data.Callejero[c][3].length !== 0){
                        opts.push(Calle.construirCalle(usig.data.Callejero[c][0], usig.data.Callejero[c][1]));
                    } else {
                        optsLowPrior.push(Calle.construirCalle(usig.data.Callejero[c][0], usig.data.Callejero[c][1]));
                    }
                    if (!isNaN(parseInt(limit)) && opts.length >= parseInt(limit))
                        break;
                }
            }
            /** junto las listas de resultado de alta y baja prioridad y devuelvo hasta la cantidad limit **/
            opts = opts.concat(optsLowPrior)
            if (!isNaN(parseInt(limit)) && opts.length >= parseInt(limit)){
                opts = opts.splice(0,limit);
            }
            if (usig.data.Callejero[0].length < 5 && !loadingData) {
                cargarCruces();
            }
        } else {
            cargarCalles();
            throw(new ErrorSinDatos());
        }
        return opts;
    },

    /**
     * Determina si una calle tiene tramos como Av.
     * @param {int} codigo numero de codigo de la calle
     * @return {Boolean} Retorna True en caso de que la calle tenga tramos como Av.
     */
    tieneTramosComoAv: (codigo) => {
		/* ATTENTI RAGAZZI
		 * Esto funciona estrictamente porque la base de calles viene ordenada por codigo de calles y
		 * la unica posibilidad de que una calle tenga tramos como av y calle simultaneamente es que
		 * haya un par de registros consecutivos con el mismo codigo (uno para c/caso)
		 */
        if (!callejero.listo()) throw new ErrorSinDatos();
        let index = core.binarySearch(usig.data.Callejero, codigo, (a, b) => a[0]-b);
        return index > 0 && codigo !== 0 && (usig.data.Callejero[index-1][0] === codigo || usig.data.Callejero[index+1][0] === codigo);
    },

    /**
     * Permite consultar el nombre oficial de una calle dado su codigo y una altura dada
     * @param {int} codigo Codigo oficial de la calle
     * @param {int} altura Altura de la calle
     * @return {String} Retorna el nombre de la calle asociada al codigo indicado en la altura
     * dada o una cadena vacia en caso de error de codigo o altura.
     */
    getNombreCalle: (codigo, altura) => {
        var calles = callejero.buscarPorCodigo(codigo);
        for (var i=0; i<calles.length; i++) {
            if (callejero.alturaValida(calles[i], altura)) {
                return calles[i].nombre;
            }
        }
        return "";
    },

    /**
     * Indica si ya se cargaron los datos del callejero.
     * @return {Boolean} Retorna True en caso de que ya se hayan cargado los datos del callejero.
     */
    listo: () => {
        return usig.data.Callejero && usig.data.Callejero instanceof Array && usig.data.Callejero.length !== 0;
    },

    /**
     * Indica si el componente ya ha sido inicializado.
     * @return {Boolean} Retorna True si ya se ha llamado al metodo init.
     */
    inicializado: () => {
        return initialized;
    },
    /**
     * Verifica si la altura es valida para esta calle.
     * @param {Calle} calle a validar
     * @param {int} alt Altura a validar
     * @return {Boolean} True si la altura es valida para esta calle
     */
    alturaValida: (calle, alt) => {
        calle.alturas = callejero.getAlturas(calle.codigo, calle.nombre);
        if (calle.alturas instanceof Array) {
            if (calle.alturas.length === 0) {
                throw(new ErrorCalleSinAlturas(calle.nombre));
                return false;
            }
            let valid = false;
            for(let a in calle.alturas) {
                valid = valid || ((parseInt(calle.alturas[a][0]) <= parseInt(alt)) && (parseInt(calle.alturas[a][1]) >= parseInt(alt)));
            }
            return valid;
        }
    },

    /**
     * Devuelve un string con el nombre de la calle
     * @return {String} Nombre de la calle
     */
    calleToString: (calle) => {
        return calle.nombre;
    },
};

export default callejero;



// WEBPACK FOOTER //
// ./src/Callejero.js